export const dateFormat = 'MM/DD/YYYY';
export const dateTimeFormat = 'MM/DD/YYYY HH:mm A';
export const dateTextFormat = 'ddd MMM DD, YYYY'